import { render, staticRenderFns } from "./StatusAutomations.vue?vue&type=template&id=12b431a0&scoped=true"
import script from "./StatusAutomations.vue?vue&type=script&lang=js"
export * from "./StatusAutomations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b431a0",
  null
  
)

export default component.exports